/* istanbul ignore file */
import { Component, Input } from '@angular/core';
import { IAccountCard } from 'src/app/model/sitefinity/IAccountCard';

@Component({
  selector: 'app-account-card',
  templateUrl: './account-card.component.html',
  styleUrls: ['./account-card.component.scss']
})
export class AccountCardComponent {
  @Input() accountCard: IAccountCard;
  @Input() cardIcon: string;
  @Input() ctaData: object;
}
